<template>
  <div>

    <el-row style="height: 40px">
      <el-tag type="info">买家自助修改SKU日志</el-tag>
      <el-button type="primary" size="small" @click="openModifySKu">一键开通自助修改SKU</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="skuData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">

          <el-table-column  prop="bizOrderId" label="订单号"></el-table-column>
          <el-table-column  prop="subOrderId" label="子订单号"></el-table-column>
          <el-table-column  prop="itemId" label="商品ID"></el-table-column>
          <el-table-column  prop="oldSkuId" label="旧SkuId"></el-table-column>
          <el-table-column  prop="oldOuterId" label="旧商家ID"></el-table-column>
          <el-table-column  prop="skuId" label="新SkuId"></el-table-column>
          <el-table-column  prop="outerId" label="新商家ID"></el-table-column>

        </el-table>
      </el-col>
    </el-row>
    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
      name: "ModiSKu",
      data(){
        return{
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 10,
          },

          skuData:[]
        }
      },
      methods:{
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getRateData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getRateData();
        },
        //开通自助修改SKU
        openModifySKu:function(){
          let param = {
            nick:storage.get("nick"),
          };
          $api.post("openModifySku", param, resonse=>{
            let dataResult = resonse.data;
            if(dataResult.state == 1){
              this.$message.success(dataResult.data);
            }
          })
        },
        getSkuData:function () {
          let param ={
            nick:storage.get("nick"),
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          };
          $api.post("/qmsku/get", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              let skuData = dataResult.data.sku;
              let pageObject = dataResult.data.pageObject;
              this.skuData = skuData;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else {
              this.$message.error(dataResult);
            }

          })
        },
      },
      mounted() {
        this.getSkuData();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/ModiSku.vue